module.exports = __webpack_public_path__ + "static/media/edit.95af46a5.svg";